import {GenericTable} from "@dvrt/graphql-widgets";
import {useDomainIDParam} from "@/types";
import {HasPermission, Link} from "../widgets";
import {useConcertoGenericQuery, useDomainNameQuery} from "@/hooks";
import CreateButton from "@/components/gateway/create/CreateButton";
import {GatewayListFragment, GatewayListFragmentDoc} from "./queries.generated";
import {Box} from "@mui/material";
import {defineMessage, defineMessages} from "react-intl";
import {commonTranslations} from "@/utils/translations";
import TableShortcutButton from "../TableShortcutButton";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {ContextFilters} from "@/context/AuthProvider";

const GatewayList = () => {
    const domainId = useDomainIDParam();
    const {domainName} = useDomainNameQuery(domainId);

    const domainContextFilter = ContextFilters.domain(domainName);

    const query = useConcertoGenericQuery<GatewayListFragment>("gateways", GatewayListFragmentDoc, {
        filtering: {
            argumentName: "filter",
            placeHolder: commonTranslations.filterPlaceholders.displayNameOrMobileOrE164OrShortNumber,
            idPrefix: "search-gateways",
        },
        fetchPolicy: "cache-and-network",
        extraVariables: {domainId},
        initialOrdering: ["displayName"],
    });

    return (
        <Box sx={{paddingX: 3}}>
            <GenericTable<GatewayListFragment>
                query={query}
                labels={defineMessages({
                    displayName: {id: "displayName", defaultMessage: "Name"},
                    number: {id: "unused", defaultMessage: "Unused"},
                    "number.e164": {id: "e164", defaultMessage: "E.164"},
                    "number.shortNumber": {id: "shortNumber", defaultMessage: "Short number"},
                })}
                extraColumns={[
                    {
                        path: "actions",
                        label: null,
                        renderer: (row) => {
                            return (
                                <HasPermission name="delete_gateway" contextFilter={domainContextFilter}>
                                    <TableShortcutButton
                                        shortcutPath={`${row.id}/delete`}
                                        tooltipTitle={commonTranslations.delete}
                                        buttonIcon={faTrash}
                                        color="secondary"
                                    />
                                </HasPermission>
                            );
                        },
                    },
                ]}
                createButton={
                    <HasPermission name="add_gateway">
                        <CreateButton
                            successItemPath={"gateways/gateways"}
                            domainId={domainId}
                            onSuccess={query.refetch}
                            title={defineMessage({id: "new_gateway", defaultMessage: "New gateway"})}
                        />
                    </HasPermission>
                }
                dataRenderers={{
                    displayName: (value, row) => (
                        <Link to={`/domains/${domainId}/gateways/gateways/${row.id}`}>{value}</Link>
                    ),
                }}
                orderableFields="all"
            />
        </Box>
    );
};

export default GatewayList;
